import { render, staticRenderFns } from "./DatevForm.vue?vue&type=template&id=40103ffe"
import script from "./DatevForm.vue?vue&type=script&lang=ts"
export * from "./DatevForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports